import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../../styles/subscription.css";
import { useDispatch } from "react-redux";
import config from "../../config/config";
import { logoutAction } from "../../redux/actions/logoutAction";
import CartCtaButton from "./CartCtaButton";
import { AdobeDataLayer } from '../DataLayer';
var Settings = require("../settings.json");
var Constants = require("../constants.json");

const SubscriptionPage = () => {
  const dispatch = useDispatch();

  const [addingProduct, setAddingProduct] = React.useState("");

  const [items, setItems] = useState([]);
  const url = config.BASE_URL + Settings["subscription"].replace("type", "A-Z");
  useEffect(() => {
    axios.get(url).then((response) => {
      setItems(response.data.response);
    });
  }, [url]);

  const handleSubmit = (e, pCode) => {
    e.preventDefault();
    setAddingProduct(pCode);
    let formBody = `${encodeURIComponent("productCode")}=${encodeURIComponent(
      pCode
    )}`;
    // console.log(`${Settings["baseURL"]}`);
    fetch(`/cart/put`, {
      method: "POST",
      body: formBody,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }).then((res) => {
      dispatch(logoutAction());
      window.location = res.url;
    });
  };

  

  return (
    <>
      <Helmet>
        <script src={config.ADD_TO_CART_URL}></script>
      </Helmet>
      <div className="wrapper">
      <div className="description">
        <p>Choose your subscription, </p>
        <p>unlock the encyclopedia</p>
        <Link className="button price-box-button" to="/">
          Go Back
        </Link>
        <div className="blue-line"></div>
      </div>

      <div className="pricing-section">
        {items.map(
          (item) =>
            item.active && (
              <div key={item.sku} className="pricing-box">
                <form
                  className="price-box"
                  onSubmit={(e) => handleSubmit(e, item.productCode)}
                >
                  <p className="price-box-type">{item.name}</p>
                  <div className="price-box-blue-line"></div>
                  <p className="price-box-user">{item.sku}</p>
                  <p className="price-box-desc">{item.description}</p>
                  <p className="price-box-price">
                    ${item.price}
                    {
                      item.productCode === Constants.yearlyProductCode ? (
                        <span className="price-box-duration">(Per Year*)</span>
                      ) : item.productCode === Constants.monthlyProductCode ? (
                        <span className="price-box-duration">(Per Month*)</span>
                      ) : (
                        <span className="price-box-duration"></span>
                      )
                    }
                  </p>
                  {
                    item.productCode === Constants.yearlyProductCode ? (
                      <CartCtaButton billingPlan={Constants.billingPlanYearly} item={item}/>
                    ) : item.productCode === Constants.monthlyProductCode ? (
                      <CartCtaButton billingPlan={Constants.billingPlanMonthly} item={item}/>
                    ) : (
                      <CartCtaButton billingPlan={Constants.invalidBillingPlan} item={item}/>
                    )
                  }
                </form>
              </div>
            )
        )}
      </div>
    </div>
          <AdobeDataLayer items={items}/> 
    </>
  );
};

export default SubscriptionPage;